import { useEffect, useRef, useState } from "react";
import { itemsMaster } from "../StockService";

const MIN_SEARCH_LENGTH = 2;
const DEBOUNCE_MS = 350;

/**
 * Debounced pharmacy-inventory search for Add Purchase.
 * Watches the search input so inventory refreshes on every retype,
 * independent of AsyncSelect loadOptions (menuIsOpen=false).
 */
export const usePurchaseInventorySearch = (searchQuery, clinicId, isOTC) => {
	const [results, setResults] = useState([]);
	const [loading, setLoading] = useState(false);
	const requestIdRef = useRef(0);

	useEffect(() => {
		const q = (searchQuery || "").trim();

		if (!q || q.length < MIN_SEARCH_LENGTH || !clinicId) {
			requestIdRef.current += 1;
			setResults([]);
			setLoading(false);
			return;
		}

		const reqId = ++requestIdRef.current;

		const timer = window.setTimeout(async () => {
			setLoading(true);
			try {
				const res = await itemsMaster({ search: q, clinicId });
				if (reqId !== requestIdRef.current) return;

				const data = (res.data?.data || []).filter(
					(item) => Boolean(item?.isOTC) === Boolean(isOTC)
				);
				setResults(data);
			} catch (err) {
				console.error("Purchase inventory search error:", err);
				if (reqId === requestIdRef.current) setResults([]);
			} finally {
				if (reqId === requestIdRef.current) setLoading(false);
			}
		}, DEBOUNCE_MS);

		return () => window.clearTimeout(timer);
	}, [searchQuery, clinicId, isOTC]);

	return {
		results,
		loading,
		isActive: (searchQuery || "").trim().length >= MIN_SEARCH_LENGTH,
	};
};
